/**
 * The "Sync" process is the realtime component
 * of Theatre Sessions, comprising mostly of keeping
 * cursor movements and physics simulation replicated
 * across clients.
 */

import { useJeffect, useLogger } from "@kosmod/kit";
import { TheatreState } from "./useTheatreState";
import { TheatrePosition } from "../defs";
import { ReadOnlyRef, Ref } from "@lukekaalim/act";
import { PhysicsDiceID, TheatreController, TheatreMatrix4 } from "..";
import { K3D } from "@kosmod/graphics-3d";


export const useHostSync = (
  cursorRef: ReadOnlyRef<TheatrePosition | null>,
  diceRef: Map<PhysicsDiceID, K3D.Transform>,
  controller: TheatreController
) => {
  const logger = useLogger('HostSync')

  // network sync
  useJeffect((j) => {
    let lastSync: TheatrePosition | null = null;

    const onSync = () => {
      const nextSync = cursorRef.get();

      if (diceRef.size === 0) {
        if (lastSync && nextSync) {
          if (TheatrePosition.equal(lastSync, nextSync)) {
            return;
          }
        } else if (!lastSync && !nextSync) {
          return;
        }
      }

      const dice = [...diceRef.entries()] as [PhysicsDiceID, K3D.Transform][]

      controller.sync(nextSync, dice)
      lastSync = nextSync && TheatrePosition.copy(nextSync);
    }
    const timeout = setInterval(onSync, 20);

    return () => {
      clearTimeout(timeout);
    }
  }, [])
}